<!--days:{{nextAgentD}} hours:{{nextAgentH}} min:{{nextAgentM}} sec:{{nextAgentS}}-->
<!-- header -->
<mat-toolbar>
    <div>
        @switch (m_modeState) {
            @case (m_modeEnum.UNAVAILABLE) {
                <div fxLayout="column">
                    <div class="d-flex-center">
                        <mat-icon style="color: red" class="offLineIcon">close</mat-icon>
                        <span style="padding-left: 10px">{{ 'general.supportOffline' | transloco }}</span>
                    </div>
                    <div>Support: Monday - Friday 24 Hours a day</div>
                </div>
            }
            @case (m_modeEnum.AVAILABLE) {
                <div class="d-flex-center">
                    <mat-icon style="color: green" class="offLineIcon">feedback</mat-icon>
                    <span style="padding-left: 10px">{{ 'general.suppAvailable' | transloco }}</span>
                </div>
            }
            @case (m_modeEnum.WAITING) {
                <div>
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <span>{{ 'general.waitTeam' | transloco }}</span>
                        <div style="position: relative; left: 10px; top: 10px">
                            <app-loading type="5"></app-loading>
                        </div>
                    </div>
                </div>
            }
            @case (m_modeEnum.CHATTING) {
                <div>
                    @if (m_userTyping) {
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <span>{{ 'general.suppTyping' | transloco }}</span>
                            <div style="position: relative; left: 10px; top: 8px">
                                <app-loading type="6"></app-loading>
                            </div>
                        </div>
                    }
                    @if (!m_userTyping) {
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <div>online: {{ m_supportNames[0] | StringJSV2Pipe:stringJSPipeClean }} | {{ this.userName }}</div>
                            <mat-icon style="color: green; margin-left: 10px">check_circle_outline</mat-icon>
                        </div>
                    }
                </div>
            }
            @case (m_modeEnum.DISCONNECTED) {
                <div>
                    {{ 'general.disconnected' | transloco }}
                </div>
            }
            @default {
                <div>
                </div>
            }
        }
    </div>
    <!-- <div *ngIf="devMode" style="position: absolute; right: 10px">
    live status: {{m_chatGlobal.liveStatusV2}} | id:{{studioId}} resellerId:{{resellerId}} | connected: {{this.socket?.connected}} | totalSupp: {{m_totalSupport}} / {{m_supportIds.length}} | liveStatus: {{m_chatGlobal.liveStatusV2}} | suppNames: {{m_supportNames | json}} | support ids: {{m_supportIds | json}}
  </div> -->
</mat-toolbar>

<!-- main -->
<div class="chatApp">
    <div>
        @switch (m_modeState) {
            @case (m_modeEnum.WAITING) {
                <div>
                    <app-loading type="6" [style]="{'margin-top': '200px'}"></app-loading>
                    <div style="width: 100%; text-align: center; margin-top: 30px;">
<!--                        <button color="warn" mat-raised-button (click)="openChatGPT()">-->
<!--                            <mat-icon>auto_awesome</mat-icon>-->
<!--                            - Start AI Agent-->
<!--                        </button>-->
<!--                        <br/>-->
<!--                        <br/>-->
                        <mat-label>
                            {{'general.waitForHuman' | transloco}}
                        </mat-label>
                        <br/>
                        <br/>
                        <br/>
                    </div>
                </div>
            }
            @case (m_modeEnum.UNAVAILABLE) {
                <div>
                    <app-chat-welcome (userSubmitted)="onUserSubmitted('EMAIL', $event)" value="EMAIL"></app-chat-welcome>
                </div>
            }
            @case (m_modeEnum.AVAILABLE) {
                <div>
                    <div class="itemTableWrapCustomer">
                        <app-chat-welcome [setUser]="m_user" (userSubmitted)="onUserSubmitted(m_userType, $event)" [value]="m_userType"></app-chat-welcome>
                    </div>
                </div>
            }
            @case (m_modeEnum.CHATTING) {
                <div>
                    <div>
                        <div class="main-container">
                            <div class="chat-wrapper">
                                <div [ngClass]="{'itemTableWrapCustomer': m_popupMode === true, 'itemTableWrap': m_popupMode === false}" id="container1">
                                    <div [ngStyle]="{'opacity': m_supportIds.length === 0 ? 0.3: 1}" style=" overflow: hidden">
                                        <mat-list id="container2">
                                            @for (conv of m_conversations; track conv) {
                                                <mat-list-item id="container3" class="messageEntry">
                                                    @if (conv.role === 'customer') {
                                                        <div class="textAlignLeftChat customerMessage">
                                                              <span class="chatConversationTime">
                                                                {{ conv.time | StringJSV2Pipe:stringJSPipeArgs }} | {{ conv.role }}
                                                              </span><br/>
                                                            <span class="chatConversation" [innerHTML]="conv.body | pipeSafe:'html'"></span>
                                                        </div>
                                                    }
                                                    @if (conv.role === 'support') {
                                                        <div class="textAlignRightChat supportMessage">
                                                              <span class="chatConversationTime">
                                                                {{ conv.time | StringJSV2Pipe:stringJSPipeArgs }} | {{ conv.role }}
                                                              </span><br/>
                                                            <span class="chatConversation" [innerHTML]="conv.body | pipeSafe:'html'"></span>
                                                        </div>
                                                    }
                                                </mat-list-item>
                                            }
                                        </mat-list>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <mat-toolbar color="primary" style="height: 100%;">
                        <div class="chat-controls flex-lt-sm-col" fxLayout="row" fxFill>
                            <div class="d-flex-center" style="flex: 1">
                                <mat-form-field class="userEnterText" [ngClass]="{lowOpacity: m_supportIds.length === 0}" style="width: 100%">
                                    <mat-label>{{ 'placeholder.enterText' | transloco }}</mat-label>
                                    <input #txtMain
                                           matInput type="text" [disabled]="m_supportIds.length === 0"
                                           (keydown.enter)="onSendPrivate(txtMain.value)"
                                           [(ngModel)]="m_messageModel" placeholder="" autofocus autocomplete="off"/>
                                </mat-form-field>
                                @if (isEmojiPickerVisible) {
                                    <emoji-mart class="emoji-mart"
                                                [style]="{ position: 'absolute', bottom: '80px', right: '20px' }"
                                                (emojiSelect)="addEmoji($event)" title="Choose your emoji"></emoji-mart>
                                }
                                <button matTooltip="{{'general.send' | transloco}}" [disabled]="m_supportIds.length === 0" class="userButtons" (click)="onSendPrivate(txtMain.value)" type="button" mat-icon-button>
                                    <mat-icon>send</mat-icon>
                                </button>
                            </div>
                            <div class="d-flex-center">
                                <button matTooltip="{{'general.emoji' | transloco}}" [disabled]="m_supportIds.length === 0" class="userButtons" (click)="isEmojiPickerVisible = !isEmojiPickerVisible" type="button" mat-icon-button>
                                    <mat-icon>sentiment_satisfied_alt</mat-icon>
                                </button>
                                <button matTooltip="{{'general.disconnect' | transloco}}" [disabled]="m_supportIds.length === 0" class="userButtons" (click)="onRemoveCallCustomer()" type="button" mat-icon-button>
                                    <mat-icon>close</mat-icon>
                                </button>
                                @if (!m_popupMode) {
                                    <button matTooltip="{{'general.openNewInWindow' | transloco}}" [disabled]="m_supportIds.length === 0" class="userButtons" (click)="onPopupChat()" type="button" mat-icon-button>
                                        <mat-icon>launch</mat-icon>
                                    </button>
                                }
                                <button matTooltip="{{'general.downloadTranscript' | transloco}}" class="userButtons" (click)="downloadChat()" type="button" mat-icon-button>
                                    <mat-icon>download</mat-icon>
                                </button>
                                <button matTooltip="{{'general.sendReminder' | transloco}}" [disabled]="m_supportIds.length !== 0 || !payload" class="userButtons"
                                        (click)="onRing()" type="button" mat-icon-button>
                                    <mat-icon>alarm</mat-icon>
                                </button>
                            </div>
                        </div>
                    </mat-toolbar>
                </div>
            }
            @case (m_modeEnum.DISCONNECTED) {
                <div>
                </div>
            }
            @default {
                <div>
                    DEFAULT
                </div>
            }
        }
    </div>
</div>




